import React, { Component } from 'react';
import { Modal } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import Select from 'react-select';
import * as request from 'request';
import { showToastAlert } from '../Services/Utility';
import AddCircleOutline from '@mui/icons-material/AddCircleOutline';
import Delete from '@mui/icons-material/Delete';


import brightdataCountries from '../assets/countries/brightdata.json';
import iproyalCountries from '../assets/countries/iproyal.json';
import netnutCountries from '../assets/countries/netnut.json';
import onestopCountries from '../assets/countries/onestop.json';
import oxylabsCountries from '../assets/countries/oxylabs.json';
import packetCountries from '../assets/countries/packet.json';
import smartproxyCountries from '../assets/countries/smart.json';
// import geosurfCountries from '../assets/countries/geosurf.json';

const allCountries = {
    'brightdata': brightdataCountries,
    'brightdata2': brightdataCountries,
    'iproyal': iproyalCountries,
    'netnut': netnutCountries,
    'onestop': onestopCountries,
    'oxylabs': oxylabsCountries,
    'packet': packetCountries,
    'smart': smartproxyCountries,
    'smart2': smartproxyCountries
}

// console.log(netnutCountries)
const customStyles = {
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? "gray" : "white",
        color: state.isSelected ? "white" : "black",
    }),
    noOptionsMessage: (provided, state) => ({
        ...provided,
        backgroundColor: "white",
        borderRadius: '5px',
        border: "2px solid lightgray"
    }),
    menuList: (provided, state) => ({
        ...provided,
        backgroundColor: "white",
        borderRadius: '5px',
        border: "2px solid lightgray"
    }),
}

function getAvailablePortBlock(pools, startFrom = 5001, rangeSize = 50) {
    let port = startFrom;

    while (port < 65535 - rangeSize) { // optional max port limit
        const blockStart = port;
        const blockEnd = port + rangeSize - 1;

        // Check if this block overlaps with any existing range
        const overlaps = pools.some(range => {
            return !(blockEnd < range.portStart || blockStart > range.portEnd);
        });

        if (!overlaps) {
            return { start: blockStart, end: blockEnd };
        }

        port++;
    }

    // If no block is found
    return null;
}

function hasDuplicateTwoKeys(arr, key1, key2) {
    const seen = new Set();
    for (const obj of arr) {
        const combo = `${obj[key1]}|${obj[key2]}`;
        if (seen.has(combo)) {
            return true; // Duplicate found
        }
        seen.add(combo);
    }
    return false; // No duplicates
}

class PoolModifyModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: props.showModal || false,
            myCountry: props.isUpdate ? props.myCountry : '',
            continent: null,
            tag: null,
            cc4: null,
            cc4Noc: null,
            cc3: '',
            cc2: '',
            flag: 'random',
            nports: 50,
            proxies: '',
            outs: props.countryDetail ? props.countryDetail.outs : [],
            providerList: props.isUpdate ? [] : [{ provider: null, sessionTime: '' }],
            selectedProviders: null,
            poolIndex: props.poolIndex,
        };
        this.showCC4 = false;
        // this.showCC4Noc = false;
        this.isUpdate = props.isUpdate || false;
        this.planType = props.planType;
        this.continents = ['Asia', 'Africa', 'America', 'Europe', 'Australia', 'Antarctica', 'Mexico', 'Germany'].map(x => ({ 'label': x, 'value': x }));
        this.tags = ['usa', 'eu'].map(x => ({ 'label': x, 'value': x }));
        this.providersData = props.providers;
        this.providers = props.providers.map(x => ({ 'label': x.name, 'value': x.id }));;
        this.allPools = props.allPools;
        this.subnetCC4 = props.subnetCountries.map(x => {
            const sub = x.domain.split('.')[0];
            return { 'label': x.name + ' - ' + sub, 'value': `${x.domain}-${x.portStart}-${x.portEnd}` };
        })
        // this.subnetCC4Noc = props.subnetNocCountries.map(x => {
        //     const sub = x.domain.split('.')[0];
        //     return { 'label': x.name + ' - ' + sub, 'value': `${x.domain}-${x.portStart}-${x.portEnd}` };
        // })
        if (this.isUpdate) {
            this.oldPoolData = this.allPools.find(x => x.myCountry === props.myCountry);
            this.state.continent = this.continents.find(x => x.value === this.oldPoolData.continent);
            this.state.tag = this.tags.find(x => x.value === this.oldPoolData.tag);
            this.state.cc3 = this.oldPoolData.cc3;
            this.state.cc2 = this.oldPoolData.cc2 || '';
            this.state.flag = this.oldPoolData.flag;
            this.state.nports = this.oldPoolData.nports;
            this.state.outs = this.oldPoolData.outs || [];
            let oldPrvs = [];

            if (oldPrvs.length > 0) {
                this.state.selectedProviders = this.providers.filter(x => oldPrvs.includes(x.value));
            }
        }
        this.closeModal = this.closeModal.bind(this);
    }

    closeModal = () => {
        this.setState({
            showModal: false
        });
    }

    onChange = (e) => {
        e.persist();
        this.setState({
            [e.target.id]: e.target.value
        });
    }

    onChangeOuts = (e, index, type) => {
        e.persist();
        this.setState(prevState => {
            const updatedOuts = [...prevState.outs];
            updatedOuts[index][type] = e.target.value;
            return { outs: updatedOuts };
        });
    }

    handleContinentChange = (selectedOption) => {
        this.setState({ ['continent']: selectedOption || null })
    };

    handleTagChange = (selectedOption) => {
        this.setState({ ['tag']: selectedOption || null })
    };

    handleCC4Change = (selectedOption) => {
        this.setState({ ['cc4']: selectedOption || null })
    };
    // handleNocCC4Change = (selectedOption) => {
    //     this.setState({ ['cc4Noc']: selectedOption || null })
    // };

    handleProvidersChange = (selectedOption) => {
        this.setState({ ['selectedProviders']: selectedOption || null })
        this.showCC4 = selectedOption.length > 0 && selectedOption.find(x => x.value === 'subnet') !== undefined;
        if (!this.showCC4) this.setState({ ['cc4']: null });
        // this.showCC4Noc = selectedOption.length > 0 && selectedOption.find(x => x.value === 'subnetnoc') !== undefined;
        // if (!this.showCC4Noc) this.setState({ ['cc4Noc']: null });
    };

    addProvider = () => {
        this.setState(prevState => ({
            providerList: [...prevState.providerList, { provider: null, sessionTime: '' }],
        }));
    }

    deleteProvider = (index) => {
        if (this.state.providerList.length + this.state.outs.length <= 1) {
            return showToastAlert('Error', 'Atleast one provider is required');
        }
        this.setState(prevState => {
            const updatedProviderList = [...prevState.providerList];
            updatedProviderList.splice(index, 1);
            return { providerList: updatedProviderList };
        });
    }

    deleteOuts = (index) => {
        if (this.state.outs.length + this.state.providerList.length <= 1) {
            return showToastAlert('Error', 'Atleast one provider is required');
        }
        this.setState(prevState => {
            const updatedOuts = [...prevState.outs];
            updatedOuts.splice(index, 1);
            return { outs: updatedOuts };
        });
    }

    onChangeProvider = (value, index) => {
        this.setState(prevState => {
            const updatedProviderList = [...prevState.providerList];
            updatedProviderList[index] = { provider: value };
            if (allCountries[value.value]) {
                if (allCountries[value.value]['country'] && allCountries[value.value]['country'].length > 0) {
                    updatedProviderList[index]["country"] = null;
                }
                if (allCountries[value.value]['state'] && allCountries[value.value]['state'].length > 0) {
                    updatedProviderList[index]["state"] = null
                }
                if (allCountries[value.value]['city'] && allCountries[value.value]['city'].length > 0) {
                    updatedProviderList[index]["city"] = null
                }

            } else {
                updatedProviderList[index] = { "provider": value }
            }
            return { providerList: updatedProviderList };
        });
    }

    onChangeCountry = (value, index, location) => {
        this.setState(prevState => {
            const updatedProviderList = [...prevState.providerList];
            updatedProviderList[index][location] = value;
            return { providerList: updatedProviderList };
        });
    }

    onChangeSessionTime = (e, index, type) => {
        e.persist();
        this.setState(prevState => {
            const updatedList = [...prevState.providerList];
            updatedList[index][type] = e.target.value;
            return { providerList: updatedList };
        });
    }

    cancelClicked = async (event) => {
        this.closeModal();
    }

    saveClicked = async (event) => {

        if (this.state.myCountry.trim() === '') {
            return showToastAlert('Error', 'Enter pool name');
        }
        if (this.state.continent === null) {
            return showToastAlert('Error', 'Select continent');
        }
        if (this.state.tag === null) {
            return showToastAlert('Error', 'Select tag');
        }
        if (!this.isUpdate && this.state.providerList.filter(detail => detail.provider == null).length > 0) {
            return showToastAlert('Error', 'Select provider');
        }
        // if (this.showCC4 && this.state.cc4 === null) {
        //     return showToastAlert('Error', 'Select subnet subdomain');
        // }
        // if (this.showCC4Noc && this.state.cc4Noc === null) {
        //     return showToastAlert('Error', 'Select subnet noc subdomain');
        // }
        if (this.state.cc3.trim() === '') {
            return showToastAlert('Error', 'Enter cc3 value');
        }
        // if (this.state.cc2.trim() === '') {
        //     return showToastAlert('Error', 'Enter cc2 value');
        // }
        // if (this.state.flag.trim() === '') {
        //     return showToastAlert('Error', 'Enter flag');
        // }
        // if (this.state.nports === '' || parseInt(this.state.nports) <= 0) {
        //     return showToastAlert('Error', 'Enter ports');
        // }

        if (!this.isUpdate) {
            const sameCountry = this.allPools.find(x => x.myCountry.toLowerCase() === this.state.myCountry.trim().toLowerCase());
            if (sameCountry) {
                return showToastAlert('Error', 'Pool name is already created. Enter unique name');
            }

            const sameCC3 = this.allPools.find(x => x.cc3.toLowerCase() === this.state.cc3.trim().toLowerCase());
            if (sameCC3) {
                return showToastAlert('Error', 'Subdomain is already created. Enter unique value');
            }
        }


        let dict = {
            'myCountry': this.state.myCountry,
            'continent': this.state.continent.value,
            'tag': this.state.tag.value,
            'cc3': this.state.cc3,
            // 'cc2': this.state.cc2,
            'flag': this.state.flag,
            'nports': parseInt(this.state.nports),
            // 'dawnDomain': '',
            // 'dawnFormat': '',
            // 'gangaDomain': '',
            // 'gangaFormat': '',
            // 'yamunaDomain': '',
            // 'yamunaFormat': '',
            'outs': []
        }

        if (this.isUpdate) {
            dict['outs'] = this.state.outs;
            dict['portStart'] = this.state.portStart;
            dict['portEnd'] = this.state.portEnd;
        }

        if (this.state.providerList.length) {
            this.state.providerList.forEach((prv, idx) => {
                const provider = this.providersData.find(x => x.id === prv.provider.value);
                let country = prv.country ? prv.country.value : null;
                let state = prv.state ? prv.state.value : null;
                let city = prv.city ? prv.city.value : null;
                let sessionTime = prv.sessionTime ? prv.sessionTime : null;

                let domain = '', format = '';
                if (provider.id === 'brightdata') {
                    domain = 'zproxy.lum-superproxy.io:32222';
                    let countryString = country ? `-country-${country}` : '';
                    format = `lum-customer-${provider.username}-zone-${provider.zone}${countryString}-session-glob_%.*s:${provider.password}`;
                }
                else if (provider.id === 'brightdata2') {
                    domain = 'brd.superproxy.io:22225';
                    let countryString = country ? `-country-${country}` : '';
                    format = `brd-customer-${provider.username}-zone-${provider.zone}${countryString}-session-glob_%.*s:${provider.password}`;
                }
                else if (provider.id === 'packet') {
                    domain = 'proxy.packetstream.io:31112';
                    // format = `${provider.username}:${provider.password}_country-${this.state.myCountry.split(' ').join('')}_session-%.*s`;
                    let countryString = country ? `_country-${country}` : '';
                    format = `${provider.username}:${provider.password}${countryString}_session-%.*s`;
                }
                else if (provider.id === 'subnet') { //provider.id === 'subnetnoc'
                    // let cc4 = provider.id === 'subnet' ? this.state.cc4 : this.state.cc4Noc;
                    let cc4 = this.state.cc4;
                    cc4 = cc4.value.split('-');
                    domain = `${cc4[0]}:${cc4[1]}-${cc4[2]}`;
                    format = `${provider.username}:${provider.password}-%.*s`;
                    dict['cc4'] = cc4[0].split('.')[0];
                    dict['portStart'] = cc4[1];
                    dict['portEnd'] = cc4[2];
                }
                else if (provider.id === 'oxylabs') {
                    domain = 'pr.oxylabs.io:7777';
                    let countryString = country ? `-country-${country}` : '';
                    let stateString = state ? `-state-${state}` : '';
                    let cityString = city ? `-city-${city}` : '';
                    let sessionStr = sessionTime ? `-sesstime-${sessionTime}` : '';
                    format = `user-${provider.username}${countryString}${stateString}${cityString}-session-glob_%.*s${sessionStr}:${provider.password}`;
                }
                else if (provider.id === 'smart' || provider.id === 'smart2') {
                    domain = 'gate.smartproxy.com:7000';
                    let countryString = country ? `-country-${country}` : '';
                    let stateString = state ? `-state_${state}` : '';
                    let sessionStr = sessionTime ? `-sessionduration-${sessionTime}` : '';
                    format = `user-${provider.username}${countryString}${stateString}-session-%.*s${sessionStr}:${provider.password}`;
                }
                else if (provider.id === 'smart-x') {
                    domain = 'smrt.x.proxiess.com:7000';
                    let countryString = country ? `-country-${country}` : '';
                    // let sessionStr = sessionTime? `-sessionduration-${sessionTime}` : '';
                    format = `${provider.username}:${provider.password}${countryString}-session-glob_%.*s`;
                }
                else if (provider.id === 'netnut') {
                    let countryString = country ? country : 'US';
                    domain = 'gw-axe.netnut.net:5959';
                    format = `${provider.username}-res-${countryString}-sid-%d:${provider.password}`;
                }
                // else if (provider.id === 'geosurf') {
                //     domain = `${this.state.cc2}-30m.geosurf.io:8000`;
                //     format = `${provider.username}+${this.state.cc2}+${provider.username}-%.*s:${provider.password}`;
                // }
                else if (provider.id === 'iproyal') {
                    domain = `proxy.iproyal.com:12323`;
                    let countryString = country ? `_country-${country}` : '';
                    let timeString = sessionTime ? `_lifetime-${sessionTime}m` : '';
                    format = `${provider.username}:${provider.password}${countryString}_session-%.*s${timeString}:`;
                }
                else if (provider.id === 'onestop') {
                    domain = `onestopproxies.cc:5557`;
                    let countryString = country ? `-country-${country}` : '';
                    let stateString = state ? `-state-${state}` : '';
                    let cityString = city ? `-city-${city}` : '';
                    format = `${provider.username}${countryString}${stateString}${cityString}-session-%.*s:${provider.password}`;
                }

                dict['outs'].push({
                    format: format,
                    domain: domain.split(':')[0],
                    port: domain.split(':')[1],
                })
            });
            if (this.state.proxies.trim()) {
                let proxiesData = this.state.proxies.trim().split('\n').map(x => x.trim());
                if (proxiesData.length > 0) {
                    proxiesData.map(detail => {
                        let proxy = detail.split(':');
                        if (proxy.length >= 2) {
                            dict['outs'].push({
                                format: `${proxy[2]}:${proxy[3]}`,
                                domain: proxy[0],
                                port: proxy[1]
                            });
                        } else {
                            showToastAlert('Error', 'Invalid proxy format. Use "ip:port:username:password" format.');
                        }
                    })
                }
            }
        }

        if (!dict['portStart']) {
            let portRange = getAvailablePortBlock(this.allPools)
            dict['portStart'] = portRange.start;
            dict['portEnd'] = portRange.end;
        }

        console.log("Dict", dict);


        let newData = [...this.allPools];

        if (!this.isUpdate) {
            newData.push(dict);
        } else {
            newData[this.state.poolIndex] = dict
        }
        console.log("New Data", newData);

        let isDuplicate = hasDuplicateTwoKeys(newData, 'myCountry', 'cc3');
        if (isDuplicate) {
            return showToastAlert('Error', 'Duplicate pool name or subdomain found. Please enter unique values.');
        }



        // let newData = {};
        // console.log(dict);

        // if (!this.isUpdate) {
        //     newData[this.state.myCountry] = dict;
        // }
        // console.log("All Pools",this.allPools)

        // this.allPools.forEach(x => {
        //     let dict1 = {
        //         'myCountry': x.myCountry,
        //         'continent': x.continent,
        //         'tag': x.tag,
        //         'cc3': x.cc3,
        //         'flag': x.flag,
        //         'nports': x.nports,
        //         'dawnDomain': x.dawnDomain || '',
        //         'dawnFormat': x.dawnFormat || '',
        //         'gangaDomain': x.gangaDomain || '',
        //         'gangaFormat': x.gangaFormat || '',
        //         'yamunaDomain': x.yamunaDomain || '',
        //         'yamunaFormat': x.yamunaFormat || ''
        //     }
        //     if (x.cc2) {
        //         dict1['cc2'] = x.cc2;
        //     }
        //     if (this.isUpdate && x.myCountry === this.props.myCountry) {
        //         newData[x.myCountry] = dict;
        //     }
        //     else {
        //         newData[x.myCountry] = dict1;
        //     }
        // })

        const idToken = await this.props.firebase.auth.currentUser.getIdToken(true);
        const data1 = { idToken: idToken, pools: newData }
        this.props.setLoading(true);
        const poolsData = await this.createPool(data1);
        this.props.setLoading(false);

        if (poolsData !== null) {
            this.props.successCallback(poolsData);
            showToastAlert('success', 'Pools updated successfully');
            this.closeModal();
        }
    }

    createPool = async (data) => {
        return new Promise((resolve, reject) => {
            let options = {
                method: 'POST',
                url: `${process.env.REACT_APP_API_URL}/${this.planType}/createPool`,
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            };
            return request(options, (error, response, body) => {
                let resData = body && JSON.parse(body);
                if (error || response.statusCode !== 200) {
                    let errorMessage = error ? error : resData ? resData.message : 'Error occurred while creating pool!';
                    showToastAlert('Error', errorMessage);
                    return resolve({});
                } else {
                    return resolve(resData || {});
                }
            });
        });
    }

    providerBlock = (index) => {
        return (
            <div key={`provider-${index}`} className="form-group row d-flex align-items-center">
                <label htmlFor={`providers_${index}`} className="col-sm-3 col-form-label py-0">Provider-{index}  <span className='text-danger'>*</span></label>
                <div className="col-sm-7">

                    <Select className="select" styles={customStyles} id={`providers_${index}`}
                        onChange={selectedOption => this.onChangeProvider(selectedOption, index)}
                        value={this.state.providerList[index]['provider']} placeholder="Select provider"
                        options={
                            // this.state.selectedProviders === null || this.state.selectedProviders.length < 3 ? this.providers : []
                            // this.state.selectedProviders === null ? this.providers : []
                            this.providers
                        }
                        noOptionsMessage={() => {
                            // return this.state.selectedProviders === null ? false : this.state.selectedProviders.length < 3 ? 'No options' : 'Max 3 providers are allowed';
                            return this.state.providerList[index]['provider'] === null ? false : 'No options';
                        }}
                    />
                </div>
                <div className='col-sm-1'>
                    <button className='icon-btn delete' onClick={e => this.deleteProvider(index)}><Delete /></button>
                </div>
            </div>
        )
    }


    locationBlock = (index, type) => {
        let provider = this.state.providerList[index]['provider']['value'];
        let optionList = null;
        if (allCountries[provider] && allCountries[provider][type]) {
            optionList = allCountries[provider][type].map(x => ({ label: x.name ? x.name : x.code, value: x.code }));
        } else {
            return (<></>)
        }

        let name = String(type).charAt(0).toUpperCase() + String(type).slice(1);

        return (
            <div key={`location-${index}-${type}`} className="form-group row d-flex align-items-center mt-2 mb-2">
                <label htmlFor={`${type}_${index}`} className="col-sm-3 col-form-label py-0">{name}-{index}  <span className='text-danger'></span></label>
                <div className="col-sm-8">

                    <Select className="select" styles={customStyles} id={`${type}_${index}`}
                        onChange={selectedOption => this.onChangeCountry(selectedOption, index, type)}
                        value={this.state.providerList[index][type]} placeholder={`Select ${name}`}
                        options={
                            optionList
                        }
                        noOptionsMessage={() => {
                            return this.state.providerList[index][type] === null ? false : 'No options';
                        }}
                    />
                </div>
            </div>
        )
    }


    render() {
        const { showModal } = this.state;
        return (
            <Modal
                isOpen={showModal}
                toggle={this.closeModal}
                onClosed={this.closeModal}
                className=""
                size="md"
                backdrop="static"
                centered
            >
                <div className="modal-body">
                    <div className="pop-bg-img">
                        <img src={require("assets/images/pop-bg.svg")} alt="" />
                    </div>
                    <button
                        type="button"
                        className="btn-close pop-close-btn"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={this.closeModal}
                    />
                    <div className="dash-head">
                        <img src={require("assets/images/proxy-gen.svg")} alt="" /> <h4 className="mb-0">{this.isUpdate ? 'Update Pool' : 'Create Pool'}</h4>
                    </div>

                    <div className="form-field px-2">
                        <div className="form-group row mb-3 d-flex align-items-center">
                            <label htmlFor="myCountry" className="col-sm-3 col-form-label py-0">Pool Name <span className='text-danger'>*</span></label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control" id="myCountry" onChange={this.onChange} value={this.state.myCountry} placeholder='Enter pool name' required />
                            </div>
                        </div>
                        <div className="form-group row mb-3 d-flex align-items-center">
                            <label htmlFor="continent" className="col-sm-3 col-form-label py-0">Continent <span className='text-danger'>*</span></label>
                            <div className="col-sm-9">
                                <Select className="select" styles={customStyles} id="continent" options={this.continents} onChange={this.handleContinentChange} value={this.state.continent} placeholder="Select Continent" required />
                            </div>
                        </div>
                        <div className="form-group row mb-3 d-flex align-items-center">
                            <label htmlFor="tag" className="col-sm-3 col-form-label py-0">Tag <span className='text-danger'>*</span></label>
                            <div className="col-sm-9">
                                <Select className="select" styles={customStyles} id="tag" options={this.tags} onChange={this.handleTagChange} value={this.state.tag} placeholder="Select Tag" required />
                            </div>
                        </div>

                        {/* {
                            this.showCC4 &&
                            <div className="form-group row mb-3 d-flex align-items-center">
                                <label htmlFor="cc4" className="col-sm-5 col-form-label py-0">Subnet Subdomain <span className='text-danger'>*</span></label>
                                <div className="col-sm-7">
                                    <Select className="select" styles={customStyles} id="cc4" options={this.subnetCC4} onChange={this.handleCC4Change} value={this.state.cc4} placeholder="Select domain (cc4)" required />
                                </div>
                            </div>
                        } */}
                        {/* {
                            this.showCC4Noc &&
                            <div className="form-group row mb-3 d-flex align-items-center">
                                <label htmlFor="cc4Noc" className="col-sm-5 col-form-label py-0">Subnet Noc Subdomain <span className='text-danger'>*</span></label>
                                <div className="col-sm-7">
                                    <Select className="select" id="cc4Noc" options={this.subnetCC4Noc} onChange={this.handleNocCC4Change} value={this.state.cc4Noc} placeholder="Select domain (cc4)" required />
                                </div>
                            </div>
                        } */}
                        <div className="form-group row mb-3 d-flex align-items-center">
                            <label htmlFor="cc3" className="col-sm-3 col-form-label py-0">Subdomain <span className='text-danger'>*</span></label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control" id="cc3" onChange={this.onChange} value={this.state.cc3} placeholder='Enter unique subdomain (cc3)' required />
                            </div>
                        </div>
                        {/* <div className="form-group row mb-3 d-flex align-items-center">
                            <label htmlFor="flag" className="col-sm-5 col-form-label py-0">Flag <span className='text-danger'>*</span></label>
                            <div className="col-sm-7">
                                <input type="text" className="form-control" id="flag" onChange={this.onChange} value={this.state.flag} placeholder='Enter flag' required />
                            </div>
                        </div>
                        <div className="form-group row mb-2 d-flex align-items-center">
                            <label htmlFor="nports" className="col-sm-5 col-form-label py-0">No. of Ports <span className='text-danger'>*</span></label>
                            <div className="col-sm-7">
                                <input type="number" min={1} className="form-control" id="nports" onChange={this.onChange} value={this.state.nports} placeholder='Enter ports' required />
                            </div>
                        </div> */}



                        <div className='mt-10 mb-10'>
                            {
                                this.state.outs.map((detail, index) => {
                                    return (
                                        <div className="form-group row mb-3 mt-3 d-flex align-items-center border border-gray-400 rounded" key={`out-${index}`}>
                                            <label htmlFor={`domain-${index}`} className="col-sm-3 col-form-label py-0">Domain</label>
                                            <div className="col-sm-9">
                                                <div className='row d-flex align-items-center'>
                                                    <div className='col-sm-10'>
                                                        {this.state.outs[index]['domain']}
                                                    </div>
                                                    <div className='col-sm-1'>
                                                        <button className='icon-btn delete' onClick={e => this.deleteOuts(index)}><Delete /></button>
                                                    </div>
                                                </div>
                                            </div>
                                            <label htmlFor={`format-${index}`} className="col-sm-3 col-form-label py-0">Format <span className='text-danger'>*</span></label>
                                            <div className="col-sm-9">
                                                <input type="text" className="form-control" id={`format-${index}`} onChange={(e) => this.onChangeOuts(e, index, 'format')} value={this.state.outs[index]['format']} placeholder='Enter format' />
                                            </div>
                                        </div>
                                    )
                                })

                            }
                        </div>


                        <div className="form-group row mb-3 d-flex align-items-center">
                            <label htmlFor="proxies" className="col-sm-3 col-form-label py-0">Proxies</label>
                            <div className="col-sm-9">
                                <textarea className='form-control' id="proxies" onChange={this.onChange} value={this.state.proxies} placeholder="ip:port:username:password" />
                            </div>
                        </div>

                        <div className='mb-3'>
                            {
                                this.state.providerList && this.state.providerList.length > 0 &&
                                this.state.providerList.map((detail, index) =>
                                (
                                    <div className="border border-gray-400 rounded p-3 mb-2" key={`locations-${index}`}>
                                        {this.providerBlock(index, detail.provider)}
                                        {
                                            detail.hasOwnProperty('country') ? this.locationBlock(index, 'country') : <></>
                                        }
                                        {
                                            detail.hasOwnProperty('state') ? this.locationBlock(index, 'state') : <></>
                                        }
                                        {
                                            detail.hasOwnProperty('city') ? this.locationBlock(index, 'city') : <></>
                                        }
                                        <div className="form-group row mb-3 d-flex align-items-center" key={`session-time-${index}`}>
                                            <label htmlFor={`session-time-${index}`} className="col-sm-3 col-form-label py-0">Session Time</label>
                                            <div className="col-sm-9">
                                                <input type="number" className="form-control" id={`session-time-${index}`} onChange={(e) => this.onChangeSessionTime(e, index, 'sessionTime')} value={this.state.providerList[index]['sessionTime']} placeholder='Session Time (minute)' />
                                            </div>
                                        </div>
                                    </div>
                                )
                                )
                            }
                        </div>

                        <div className='row flex justify-content-end mt-3 mb-3'>
                            <button className='icon-btn add' onClick={this.addProvider}><AddCircleOutline /></button>
                        </div>





                        <div className="row">
                            <div className="col-sm-12 text-end">
                                <div className="d-inline-block mt-4 me-2">
                                    <a href="#" className="mb-3 px-5 cta-white" onClick={this.cancelClicked}>Cancel</a>
                                </div>
                                <div className="form-cta-btn d-inline-block mt-4">
                                    <a href="#" className="mb-3 px-5 text-light" style={{ 'boxShadow': '0px 6px 8px 3px #2c3d7926' }} onClick={this.saveClicked}>{this.isUpdate ? 'Update' : 'Create'}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </Modal>
        );
    }
}

export default withRouter(PoolModifyModal);
